import { render, staticRenderFns } from "./AttachImage.vue?vue&type=template&id=96e0fae8&"
import script from "./AttachImage.vue?vue&type=script&lang=js&"
export * from "./AttachImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports